import React from "react";

export const Cart: React.FC<DogsTrust.IconProps> = ({
	height = "26px",
	width = "26px",
	...props
}) => {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			width={width}
			height={height}
			viewBox="0 0 100 100"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<defs>
				<clipPath id="icon_cart_svg__b">
					<path
						className="icon_cart_svg__i"
						d="M88.33 67.65H29.86c-2.99 0-5.57-2.25-5.99-5.23l-5.25-39.73c-.48-3.37-3.82-6.24-7.3-6.24H3.78C1.69 16.45 0 14.74 0 12.64s1.69-3.81 3.78-3.81h7.53c7.28 0 13.78 5.63 14.8 12.82l.22 1.66h67.62c1.8 0 3.48.79 4.64 2.18a6.093 6.093 0 0 1 1.32 4.98L94.29 62.6c-.51 2.92-3.02 5.04-5.96 5.04Zm-57.14-7.63h55.87l5.09-29.08H27.34l3.85 29.08Z"
					/>
				</clipPath>
				<clipPath id="icon_cart_svg__c">
					<path className="icon_cart_svg__h" d="M0 8.82h100v58.82H0z" />
				</clipPath>
				<clipPath id="icon_cart_svg__d">
					<path
						className="icon_cart_svg__i"
						d="M39.71 91.18c-5.68 0-10.29-4.62-10.29-10.29S34.04 70.6 39.71 70.6 50 75.22 50 80.89s-4.62 10.29-10.29 10.29m0-13.39c-1.71 0-3.1 1.39-3.1 3.1s1.39 3.1 3.1 3.1 3.1-1.39 3.1-3.1-1.39-3.1-3.1-3.1"
					/>
				</clipPath>
				<clipPath id="icon_cart_svg__e">
					<path className="icon_cart_svg__h" d="M29.41 70.59H50v20.59H29.41z" />
				</clipPath>
				<clipPath id="icon_cart_svg__f">
					<path
						className="icon_cart_svg__i"
						d="M80.88 91.18c-5.68 0-10.29-4.62-10.29-10.29S75.21 70.6 80.88 70.6s10.29 4.62 10.29 10.29-4.62 10.29-10.29 10.29m0-13.39c-1.71 0-3.1 1.39-3.1 3.1s1.39 3.1 3.1 3.1 3.1-1.39 3.1-3.1-1.39-3.1-3.1-3.1"
					/>
				</clipPath>
				<clipPath id="icon_cart_svg__g">
					<path
						className="icon_cart_svg__h"
						d="M70.59 70.59h20.59v20.59H70.59z"
					/>
				</clipPath>
				<style>
					{
						".icon_cart_svg__h,.icon_cart_svg__i{fill:none}.icon_cart_svg__i{clip-rule:evenodd}"
					}
				</style>
			</defs>
			<g
				style={{
					clipPath: "url(#icon_cart_svg__b)",
				}}
			>
				<path
					d="M-2.94 5.88h105.88v64.71H-2.94z"
					style={{
						clipPath: "url(#icon_cart_svg__c)",
					}}
				/>
			</g>
			<g
				style={{
					clipPath: "url(#icon_cart_svg__d)",
				}}
			>
				<path
					d="M26.47 67.65h26.47v26.47H26.47z"
					style={{
						clipPath: "url(#icon_cart_svg__e)",
					}}
				/>
			</g>
			<g
				style={{
					clipPath: "url(#icon_cart_svg__f)",
				}}
			>
				<path
					d="M67.65 67.65h26.47v26.47H67.65z"
					style={{
						clipPath: "url(#icon_cart_svg__g)",
					}}
				/>
			</g>
		</svg>
	);
};

export default Cart;
